import { Routes } from '@angular/router';
import { MacroStepId, StepId } from 'models';
import { ProcessComponent } from './components/process/process.component';
import { ActivationOtpComponent } from './components/steps/activation-otp/activation-otp.component';
import { ActivationComponent } from './components/steps/activation/activation.component';
import { AddressComponent } from './components/steps/address/address.component';
import { ConsentsComponent } from './components/steps/consents/consents.component';
import { ContactsComponent } from './components/steps/contacts/contacts.component';
import { CouponComponent } from './components/steps/coupon/coupon.component';
import { CustomerComponent } from './components/steps/customer/customer.component';
import { DigitalOnboardingIccidComponent } from './components/steps/digital-onboarding-iccid/digital-onboarding-iccid.component';
import { DocumentComponent } from './components/steps/document/document.component';
import { OfferExtrasComponent } from './components/steps/offer-extras/offer-extras.component';
import { PaymentMethodComponent } from './components/steps/payment-method/payment-method.component';
import { PaymentComponent } from './components/steps/payment/payment.component';
import { ShippingMethodComponent } from './components/steps/shipping-method/shipping-method.component';
import { SimTypeComponent } from './components/steps/sim-type/sim-type.component';
import { SummaryComponent } from './components/steps/summary/summary.component';
import { WinbackComponent } from './components/steps/winback/winback.component';
import { BackUrlGuard } from './guards/back-url/back-url.guard';
import { CanDeactivateGuard } from './guards/can-deactivate/can-deactivate.guard';
const ɵ0 = { animation: MacroStepId.Process }, ɵ1 = { animation: StepId.Shipping }, ɵ2 = { animation: StepId.Coupon }, ɵ3 = { animation: StepId.Consents }, ɵ4 = { animation: StepId.Customer }, ɵ5 = { animation: StepId.Document }, ɵ6 = { animation: StepId.Contacts }, ɵ7 = { animation: StepId.Activation }, ɵ8 = { animation: StepId.ActivationOtp }, ɵ9 = { animation: StepId.Address }, ɵ10 = { animation: StepId.PaymentMethod }, ɵ11 = { animation: StepId.Payment }, ɵ12 = { animation: StepId.Winback }, ɵ13 = { animation: StepId.FDOIccid }, ɵ14 = { animation: StepId.Sim }, ɵ15 = { animation: StepId.OfferExtras }, ɵ16 = { animation: StepId.Summary };
const routes = [
    {
        path: '',
        data: ɵ0,
        component: ProcessComponent,
        children: [
            {
                path: StepId.Shipping,
                data: ɵ1,
                component: ShippingMethodComponent
            },
            {
                path: StepId.Coupon,
                data: ɵ2,
                component: CouponComponent
            },
            {
                path: StepId.Consents,
                data: ɵ3,
                component: ConsentsComponent
            },
            {
                path: StepId.Customer,
                data: ɵ4,
                component: CustomerComponent,
                canDeactivate: [BackUrlGuard]
            },
            {
                path: StepId.Document,
                data: ɵ5,
                component: DocumentComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: StepId.Contacts,
                data: ɵ6,
                component: ContactsComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: StepId.Activation,
                data: ɵ7,
                component: ActivationComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: StepId.ActivationOtp,
                data: ɵ8,
                component: ActivationOtpComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: StepId.Address,
                data: ɵ9,
                component: AddressComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: StepId.PaymentMethod,
                data: ɵ10,
                component: PaymentMethodComponent
            },
            {
                path: StepId.Payment,
                data: ɵ11,
                component: PaymentComponent
            },
            {
                path: StepId.Winback,
                data: ɵ12,
                component: WinbackComponent
            },
            {
                path: StepId.FDOIccid,
                data: ɵ13,
                component: DigitalOnboardingIccidComponent
            },
            {
                path: StepId.Sim,
                data: ɵ14,
                component: SimTypeComponent
            },
            {
                path: StepId.OfferExtras,
                data: ɵ15,
                component: OfferExtrasComponent
            },
            {
                path: StepId.Summary,
                data: ɵ16,
                component: SummaryComponent
            },
            {
                path: '',
                redirectTo: StepId.Customer,
                pathMatch: 'full'
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/not-found'
    }
];
export class ProcessRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16 };
